import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import Tooltip from "../../components/Tooltip/Tooltip.jsx";
import Button from "../../components/Button/Button.jsx";

import WrapperContainer from "../../components/WrapperContainer/WrapperContainer.jsx";
import ServiceHome from "../../features/ChoiceServices/ServiceHome.jsx";

import ShimmerMultiLine from "../../components/Shimmer/ShimmerMultiLine.jsx";
import Error from "../../features/Error.jsx";

import Alert from "../../components/Alert/Alert.jsx";
import Input from "../../components/Input/Input.jsx";

import SvgIcon from "../../components/Icon/SvgIcon.jsx";
import { TECHNOLOGY_TYPE } from "../../utils/consts/technologyType";

import { apiFetchTariffList } from "../../api/methods/tariffs.js";
import {
  apiFetchStatusProcess,
  apiChangeProcess,
  apiFetchProcess,
} from "../../api/methods/process.js";
import actions from "../../store/actions.js";

import { changeInput } from "../../utils/helpers/validateFields.js";
import { apiCreateServices } from "../../api/methods/services.js";

import { APP_ROUTES } from "../../router";
import { SERVICES_HOME } from "../../utils/consts/service";

import { PROCESS_STATUS } from "../../utils/consts/processStatus";
import { FIELD_VALIDATION_RULES } from "../../utils/consts/validationRule";

import "../../features/ChoiceServices/styles/style.scss";

const ChoiceServiceListHome = () => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const { mobileConnectionInfo } = useSelector(state => state);

  // Исходный перечень тарифов получаемых с сервера
  const [tariffs, setTariffs] = useState([]);

  // Результирующий перечень тарифов необходимых для подключения
  const [selectedTariffs, setSelectedTariffs] = useState([]);

  // Отдельные параметры процесса МПУ
  const [paramsProcess, setParamsProcess] = useState({});
  const [statusProcessId, setStatusProcessId] = useState(null);

  const [passphrase, setPassphrase] = useState("");
  const [tariffsCost, setTariffsCost] = useState(0);

  const [indexActive, setIndexActive] = useState(-1);
  const [isFetchData, setIsFetchData] = useState(false);

  const [hasError, setHasError] = useState(false);
  const [passphraseErrorText, setPassphraseErrorText] = useState([]);

  const refSvgTooltip = useRef();

  // Информация о тарифе интернет (в том числе и в составе пакета)
  const inetTariff = selectedTariffs.find(({ service: serviceName }) => {
    return (
      serviceName === SERVICES_HOME.INTERNET.name ||
      serviceName === SERVICES_HOME.INTERNET_TV.name ||
      serviceName === SERVICES_HOME.INTERNET_IPTV.name
    );
  });

  const { apiKey } = mobileConnectionInfo;

  useEffect(() => {
    if (!apiKey) {
      history(APP_ROUTES.MOBILE_CONNECTION.ROOT_ROUTE, { replace: true });
      return;
    }

    (async () => {
      try {
        setIsFetchData(true);
        const tariffs = await apiFetchTariffList(apiKey);
        setTariffs(tariffs);

        const processStatus = await apiFetchStatusProcess(apiKey);
        setStatusProcessId(processStatus);

        const paramsProcess = await apiFetchProcess(apiKey, [
          "cost_connection",
          "address",
          "contract",
          "network_type",
          "number_months",
          "limitation",
        ]);
        setParamsProcess(paramsProcess);

        // Если ранее были подключены некоторые услуги на договоре
        const { contract } = paramsProcess;
        if (contract?.services) {
          const existTariffList = contract.services.map(service => ({
            service: service.type,
          }));
          setSelectedTariffs(existTariffList);
        }
      } catch {
        setHasError(true);
      } finally {
        setIsFetchData(false);
      }
    })();
  }, []);

  const { contract, address, networkType, limitation, costConnection, numberMonths } =
    paramsProcess;

  /**
   * Сформировать перечень выбранных тарифов по услугам
   *
   * @param {Object} currentTariff
   * // Флаг, позволяющий по нажатию на Switch удалить тариф по услуге из resultList
   * @param {Boolean} isClickSwitch
   */
  const combineTariffs = (currentTariff, isClickSwitch = false) => {
    const resultList = selectedTariffs;
    const { service } = currentTariff;

    const isServiceInet = service === SERVICES_HOME.INTERNET.name;
    const isServiceInetTv = service === SERVICES_HOME.INTERNET_TV.name;
    const isServiceInetIptv = service === SERVICES_HOME.INTERNET_IPTV.name;

    const indexExistInetTariff = resultList.findIndex(
      tariff => tariff.service === SERVICES_HOME.INTERNET.name
    );

    const indexExistIptvTariff = resultList.findIndex(
      tariff => tariff.service === SERVICES_HOME.IPTV.name
    );

    /**
     * При выборе тарифа из пакета Интернет+TV/Интернет+IPTV
     * моно услуга Интернет исключается из resultList
     */
    if ((isServiceInetTv || isServiceInetIptv) && indexExistInetTariff !== -1) {
      resultList.splice(indexExistInetTariff, 1);
    }

    /**
     * В дрс при переключении тумблера для моно услуги Интернет в состояние Неактивен
     * необходимо исключить из resultList услугу УфанетТВ/ТВскоп
     */
    if (isServiceInet && indexExistIptvTariff !== -1) {
      resultList.splice(indexExistIptvTariff, 1);
    }

    /**
     * Признак, что выбранный тариф определенной услуги
     * уже был ранее выбран и содержится в resultList
     */
    const isEqualService = resultList.some(tariff => tariff.service === service);

    if (isEqualService) {
      const indexExistTariff = resultList.findIndex(tariff => tariff.service === service);
      resultList.splice(indexExistTariff, 1);

      if (!isClickSwitch) {
        resultList.push(currentTariff);
      }

      getTotalCost(resultList);
      setSelectedTariffs(resultList);
    } else {
      getTotalCost([...resultList, currentTariff]);
      setSelectedTariffs(prevState => [...prevState, currentTariff]);
    }
  };

  /**
   * Изменить индекс просматриваемой группы тарифов услуги
   *
   * @param {Number} index
   */
  const changeIndexActive = index => {
    if (index === -1) {
      // Нажатие на компонент Switch
      setIndexActive(-1);
    } else {
      // Нажатие на блок вне компонента Switch
      setIndexActive(prevState => (prevState === index ? -1 : index));
    }
  };

  const isProgramAlpha = localStorage.getItem("partnerProgram") === "alpha";

  // Признак того, что на определенном адресе нужно внести N количество абонентских плат
  const isExistExtraPayment = numberMonths > 1;

  // В зависимости от технологии строительства будут доступны определенные услуги
  const isPonAddress = networkType === TECHNOLOGY_TYPE.PON.typeId;

  /**
   * Создать субдоговоры по выбранным услугам
   */
  const createServices = async () => {
    try {
      const ctvTariff = selectedTariffs.find(
        tariff =>
          (tariff.service === SERVICES_HOME.TV.name ||
            tariff.service === SERVICES_HOME.INTERNET_TV.name) &&
          tariff.title
      );

      const iptvTariff = selectedTariffs.find(
        tariff =>
          (tariff.service === SERVICES_HOME.IPTV.name ||
            tariff.service === SERVICES_HOME.INTERNET_IPTV.name) &&
          tariff.title
      );

      const selectedInetTariff = selectedTariffs.find(
        tariff => tariff.service === SERVICES_HOME.INTERNET.name && tariff.cost
      );

      await apiChangeProcess(apiKey, {
        cost_services: isExistExtraPayment ? tariffsCost * numberMonths : tariffsCost,
      });

      if (!isPonAddress && selectedInetTariff) {
        dispatch(
          actions.mobileConnection.changeConnectionData({
            ...mobileConnectionInfo,
            inetTariffId: inetTariff?.tariffId,
            ctvTariff,
            iptvTariff,
            cctvTariff: null,
            passphrase,
          })
        );

        history(APP_ROUTES.MOBILE_CONNECTION.CONFIRM_INTERNET_CABLE);
      } else {
        await apiCreateServices(
          apiKey,
          inetTariff?.tariffId,
          null,
          ctvTariff,
          iptvTariff,
          null,
          passphrase
        );

        if (!inetTariff?.tariffId) localStorage.removeItem("partnerProgram");
        history(APP_ROUTES.MOBILE_CONNECTION.PAYMENT_ROUTE);
      }
    } catch {
      setHasError(true);
    }
  };

  /**
   * Получить общую стоимость выбранных тарифов по услугам (абонентская плата в месяц)
   *
   * @param {Array} tariffs
   */
  const getTotalCost = tariffs => {
    const cost = tariffs.reduce((total, tariff) => {
      return total + (tariff.cost || 0);
    }, 0);

    setTariffsCost(cost);
  };

  /**
   * Проверить доступность услуги.
   *
   * Если ранее уже был создан субдоговор услуги,
   * то станет невозможным внести изменения для такой услуги.
   * Будет рендер, но не будет возможности для управления услугой
   *
   * @param {Array} services
   * @return {Boolean}
   */
  const checkAvailabilityService = services => {
    const uniqServiceList = _.uniqBy(services, "service");
    const { contract } = paramsProcess;

    if (!_.isEmpty(contract)) {
      const existServiceList = contract.services.map(tariff => tariff.type);
      return uniqServiceList.some(tariff => existServiceList.includes(tariff.service));
    }

    return false;
  };

  // Отсортированный перечень тарифов по услуге Интернет
  const tariffsInet = tariffs
    .filter(tariff => tariff.service === SERVICES_HOME.INTERNET.name)
    .sort((prev, next) => prev.parameterOne - next.parameterOne);

  /**
   * Отсортированный перечень тарифов по пакету Интернет+IPTV.
   * Доступно к подключению только в поне
   */
  const tariffsInternetIptv = tariffs
    .filter(tariff => tariff.service === SERVICES_HOME.INTERNET_IPTV.name)
    .sort((prev, next) => prev.parameterOne - next.parameterOne);

  /**
   * Отсортированный перечень тарифов по пакету Интернет+TV.
   * Доступно к подключению только в поне
   */
  const tariffsInternetTv = tariffs
    .filter(tariff => tariff.service === SERVICES_HOME.INTERNET_TV.name)
    .sort((prev, next) => prev.parameterOne - next.parameterOne);

  /**
   * Услуга Телевидение отдельно может подключаться только если адрес ДРС.
   * В поне услуга отдельно не отображается, доступна только в рамках пакета
   */
  const tariffsTv = tariffs.filter(tariff => tariff.service === SERVICES_HOME.TV.name);

  /**
   * Услуга УфанетТВ/ТВскоп отдельно может подключаться только если адрес ДРС
   * и при этом выбран тариф интернета.
   * В поне услуга отдельно не отображается
   */
  const tariffsIptv = tariffs.filter(tariff => tariff.service === SERVICES_HOME.IPTV.name);

  /**
   * Получить результирующий перечень услуг для отображения
   */
  const getServiceList = () => {
    /**
     * Признак того, что выбран пакетный тариф Интернет+ТВ/Интернет+IPTV.
     * В поне в таком случае выбор тарифа интернета отдельно станет невозможным
     */
    const isExistPacketInternet = selectedTariffs.some(
      ({ service: serviceName }) =>
        serviceName === SERVICES_HOME.INTERNET_TV.name ||
        serviceName === SERVICES_HOME.INTERNET_IPTV.name
    );

    /**
     * Признак того, что выбран тариф моно услуги Интернет.
     * В поне в таком случае выбор пакетного тарифа Интернет+ТВ/Интернет+IPTV станет невозможным
     */
    const isExistOnlyInternet = selectedTariffs.some(
      tariff => tariff.service === SERVICES_HOME.INTERNET.name
    );

    let services = [];
    services = [
      {
        title: SERVICES_HOME.INTERNET.name,
        tariffsCurrentService: tariffsInet,
        isDisabled: checkAvailabilityService(tariffsInet) || isExistPacketInternet,
        isExist: checkAvailabilityService(tariffsInet),
        order: 3,
      },
    ];

    if (isPonAddress) {
      services = [
        ...services,
        {
          title: SERVICES_HOME.INTERNET_IPTV.name,
          tariffsCurrentService: tariffsInternetIptv,
          isDisabled: checkAvailabilityService(tariffsInternetIptv) || isExistOnlyInternet,
          isExist: checkAvailabilityService(tariffsInternetIptv),
          order: 1,
        },
        {
          title: SERVICES_HOME.INTERNET_TV.name,
          tariffsCurrentService: tariffsInternetTv,
          isDisabled: checkAvailabilityService(tariffsInternetTv) || isExistOnlyInternet,
          isExist: checkAvailabilityService(tariffsInternetTv),
          order: 2,
        },
      ];
    } else {
      services = [
        ...services,
        {
          title: SERVICES_HOME.TV.name,
          tariffsCurrentService: tariffsTv,
          isDisabled: checkAvailabilityService(tariffsTv),
          isExist: checkAvailabilityService(tariffsTv),
          order: 4,
          isAutoSelect: true,
        },
        {
          title: SERVICES_HOME.IPTV.name,
          tariffsCurrentService: tariffsIptv,
          isDisabled: checkAvailabilityService(tariffsIptv) || !inetTariff,
          isExist: checkAvailabilityService(tariffsIptv),
          order: 5,
          isAutoSelect: true,
        },
      ];
    }

    return services.sort((prev, next) => prev.order - next.order);
  };

  const services = getServiceList();
  const changePassphrase = event => {
    // TODO: upgrade to RHF
    const value = event.target.value.replace(/[^А-ЯЁ]/gi, "");

    const options = [
      {
        type: FIELD_VALIDATION_RULES.COMPARE_MIN_LENGTH,
        condition: value.length <= 2,
        targets: [value],
        refs: [event.target],
        error: "Длина кодовой фразы не может быть менее 3х символов",
        setter: setPassphraseErrorText,
      },
    ];

    changeInput(value, setPassphrase, options);
  };

  const redirectToAuth = () => window.open("https://my.ufanet.ru/", "_blank");

  const isExistInet =
    checkAvailabilityService(tariffsInet) ||
    checkAvailabilityService(tariffsInternetIptv) ||
    checkAvailabilityService(tariffsInternetTv);

  const needSelectInet =
    isProgramAlpha && !isExistInet && !inetTariff && selectedTariffs.length > 0;

  /**
   * Признак того, что статус процесса "Выбор услуг без кодовой фразы".
   * В таком случае не нужно отображать поле для ввода кодовой фразы
   */
  const isStatusWithoutPassphrase = statusProcessId === PROCESS_STATUS.CHOICE_SERVICES;

  // Признак того, что ранее были созданы субдоговоры для всех доступных услуг на адресе
  const isAllServicesCreated = services.every(service => service.isDisabled);

  const containerTitle =
    isStatusWithoutPassphrase && contract ? `Договор ${contract?.contractNumber}` : "Услуги";

  const containerDescription =
    isStatusWithoutPassphrase && address ? address : "Выберите тариф и подберите кодовую фразу.";

  const newTariffs = selectedTariffs.filter(tariff => tariff.title);
  const isDisabledButton =
    (isStatusWithoutPassphrase && !newTariffs.length) ||
    (!isStatusWithoutPassphrase && (!newTariffs.length || passphrase.length <= 2));

  if (hasError) return <Error />;
  if (isFetchData) return <ShimmerMultiLine count={2} />;

  return (
    <>
      <WrapperContainer gap="16" title="sm">
        {containerTitle}
      </WrapperContainer>

      <div className="forms-container__content">
        <WrapperContainer gap="24" text="lg">
          {containerDescription}
        </WrapperContainer>

        {limitation && (
          <WrapperContainer gap="24">
            <Alert type="warn">{limitation}</Alert>
          </WrapperContainer>
        )}

        {needSelectInet && (
          <WrapperContainer gap="24">
            <Alert type="warn">Для начисления кешбэка, необходимо подключить Интернет</Alert>
          </WrapperContainer>
        )}

        {isExistInet && isProgramAlpha && (
          <WrapperContainer gap="24">
            <Alert type="warn">
              На вашем договоре уже подключен интернет. Начисление кешбэка не доступно
            </Alert>
          </WrapperContainer>
        )}

        {isAllServicesCreated && (
          <WrapperContainer gap="24">
            <Alert type="success">
              Вы уже пользуетесь нашими услугами. Для управления ими перейдите в личный кабинет
            </Alert>
          </WrapperContainer>
        )}

        <WrapperContainer gap="24" className="item-list item-list--home-services">
          {services.map((service, index) => (
            <ServiceHome
              key={index}
              {...service}
              tariffsAllServices={selectedTariffs}
              indexCurrent={index}
              indexActive={indexActive}
              changeIndexActive={changeIndexActive}
              getTariff={combineTariffs}
            />
          ))}
        </WrapperContainer>

        <form onSubmit={event => event.preventDefault()}>
          {!isStatusWithoutPassphrase && (
            <WrapperContainer gap="24">
              <Input
                placeholder="Кодовая фраза"
                onChange={changePassphrase}
                value={passphrase}
                maxLength={14}
                validationErrors={passphraseErrorText}
              >
                <Tooltip
                  content={`Кодовая фраза понадобится для идентификации в нашем Call-центре. Длина фразы -
                        от 3 до 14 символов (только русскими буквами).`}
                >
                  <SvgIcon name="help" color="#AAABAD" className="clickable" ref={refSvgTooltip} />
                </Tooltip>
              </Input>
            </WrapperContainer>
          )}

          {!!tariffsCost && (
            <WrapperContainer gap="24">
              <div className="total-cost">
                <div className="total-cost__label">Стоимость тарифа:</div>
                <div className="total-cost__value">
                  <div className="total-cost__cost">
                    {tariffsCost}
                    {isExistExtraPayment && "*"}
                  </div>
                  <div className="total-cost__unit">
                    <div className="total-cost__unit-top">руб.</div>
                    <div className="total-cost__unit-bottom">мес.</div>
                  </div>
                </div>
              </div>

              {!!costConnection && (
                <div className="total-cost">
                  <div className="total-cost__label">Стоимость подключения:</div>
                  <div className="total-cost__value">
                    <div className="total-cost__cost">{costConnection}</div>
                    <div className="total-cost__unit">
                      <div className="total-cost__unit-top">руб.</div>
                    </div>
                  </div>
                </div>
              )}

              {isExistExtraPayment && (
                <WrapperContainer text="sm" align="right" className="text-color-dark-gray">
                  *По условиям подключения нужно внести {numberMonths} абонентские платы наперед.
                </WrapperContainer>
              )}
            </WrapperContainer>
          )}

          {isAllServicesCreated ? (
            <Button isStretch color="primary" size="xl" onClick={redirectToAuth}>
              В личный кабинет
            </Button>
          ) : (
            <Button
              isSubmit
              isStretch
              color="primary"
              size="xl"
              onClick={createServices}
              disabled={isDisabledButton}
            >
              Далее
            </Button>
          )}
        </form>
      </div>
    </>
  );
};

export default ChoiceServiceListHome;
